export const POOLING_INTERVAL = 3000;

export const WINDOW_RELOAD_TIMEOUT = 3000;
